/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import { Dimensions, StyleSheet, Platform } from 'react-native';
const isLandscape = () => {
  const dim = Dimensions.get('screen');
  return dim.height < dim.width;
};
let inputWidth;
if (Platform.OS === 'web' && isLandscape()) {
 inputWidth = "30%";
}
else {
 inputWidth = "90%";
}



export default StyleSheet.create({
container: {
flex: 1,
backgroundColor: 'white',
flexDirection: 'row',
alignItems: 'center',
justifyContent: 'center',
marginBottom: Platform.OS === 'web'? 0: 90,
},
containerCol: {
flex: 1,
backgroundColor: 'white',
flexDirection: 'column',
justifyContent: 'center',
},
headerTitle: {
margin: 10,
fontSize: 20,
fontWeight: 'bold',
textAlign: 'center',
},
headerSubtitle: {
textAlign: 'center',
marginBottom: 20,
},
actionInput: {
width: inputWidth,
alignSelf: 'center',
},
button: {
alignSelf: 'center',
width: inputWidth,
marginTop: 10,
backgroundColor: 'black',
},
subtitleView: {
flexDirection: 'row',
paddingTop: 5
},
subtitleText: {
color: 'gray',
},
titleText: {
color: 'black',
},
image: {
height: 50,
width: 50,
aspectRatio: 3/4,
resizeMode: 'contain',
borderRadius: 22/2,
marginRight: 20,
},
})